<template>
  <AgGridRenderList
    :columnDefs="columnDefs"
    :rowData="rowData"
    :totalRows="totalRows"
    :lastPage="lastPage"
    :loading="paginationLoading"
    @updatePagination="updatePagination"
    @updateItemPerPage="updateItemPerPage"
  />
</template>

<script>
import General from "../../../../../../Mixins/general";
import AgvmenuCustom from "../../../../../../views/dashboard/components/general/AgGridComponents/Ag-vmenuCustom.vue";
import Agvmenu from "../../../../../../views/dashboard/components/general/AgGridComponents/Ag-vmenu.vue";
import moment from "moment-jalaali";

export default {
  components: { AgvmenuCustom, Agvmenu },
  props: {
    callRefresh: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    callFunction: {
      type: Boolean,
      default: false,
    },
    row: {
      type: [Array, Object],
      default: {},
    },
  },
  data() {
    return {
      columnDefs: null,
      rowData: null,
      totalRows: null,
      lastPage: null,
      invoiceIds: null,
      filterDialog: false,
      toDate: null,
      optionsNew: {
        page: 1,
        itemsPerPage: 10,
      },
      account: null,
      sellStatus: null,
      currencyFilter: null,
      fromAmount: null,
      fromNumber: null,
      fromDate: null,
      toAmount: null,
      toNumber: null,
      toDate: null,
      tag: null,
      category: null,
      branch: null,
      entrepot: null,
      lockStatus: null,
      registerar: null,
      payedStatus: null,
      fromTime: null,
      toTime: null,
      customFields: null,
      paginationLoading: false,
      showActionColumn: false,
    };
  },
  mixins: [General],
  mounted() {
    this.columnDefs = [
      {
        headerName: "",
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 80,
        maxWidth: 80,
        minWidth: 50,
        cellRenderer: "Agvmenu",
        cellRendererParams: (params) => {
          const items = [];
          if (params.data?.status === "done") {
            items.push(
              {
                label: this.$t("print_salary_slip"),
                icon: "mdi-receipt-text-outline",
                iconColor: "gray",
                action: (rowData) => this.goToDocuments(rowData, 2),
              },
              {
                label: this.$t("print_payroll_list"),
                icon: "mdi-format-list-bulleted",
                iconColor: "gray",
                action: (rowData) => this.goToDocuments(rowData, 3),
              },
              {
                label: this.$t("print_list_summary"),
                icon: "mdi-clipboard-text-outline",
                iconColor: "gray",
                action: (rowData) => this.goToDocuments(rowData, 4),
              },
              {
                label: this.$t("insurance_disc"),
                icon: "mdi-shield-account-outline",
                iconColor: "gray",
                action: (rowData) => this.goToDocuments(rowData, 0),
              },
              {
                label: this.$t("tax_disc"),
                icon: "mdi-file-percent-outline",
                iconColor: "gray",
                action: (rowData) => this.goToDocuments(rowData, 1),
              },
              {
                label: this.$t("bank_disc"),
                icon: "mdi-bank-outline",
                iconColor: "gray",
                action: (rowData) => this.goToDocuments(rowData, 6),
              },
              {
                label: this.$t("attachments"),
                icon: "mdi-paperclip",
                iconColor: "gray",
                action: (rowData) => this.goToDocuments(rowData, 7),
              },
              {
                label: this.$t("print_insurance_list"),
                icon: "mdi-file-document-multiple-outline",
                iconColor: "gray",
                action: (rowData) => this.goToDocuments(rowData, 5),
              },
              {
                label: this.$t("review_and_Edit"),
                icon: "mdi-pencil",
                iconColor: "gray",
                action: (rowData) => this.editActionAfterDone(rowData),
              },
              {
                label: this.$t("delete"),
                icon: "mdi-trash-can-outline",
                iconColor: "gray",
                action: (rowData) => this.deleteAction(rowData),
              }
            );
          }
          if (params.data?.status === "pending") {
            items.push(
              {
                label: this.$t("review_and_Edit"),
                icon: "mdi-pencil",
                iconColor: "gray",
                action: (rowData) => this.editAction(rowData),
              },
              {
                label: this.$t("delete"),
                icon: "mdi-trash-can-outline",
                iconColor: "gray",
                action: (rowData) => this.deleteAction(rowData),
              }
            );
          }

          return {
            items,
            width: 260,
          };
        },
        resizable: false,
        pinned: "right",
      },
      {
        headerName: "#",
        colId: "rowNumber",
        valueGetter: (params) => params.node.rowIndex + 1,
        width: 70,
        maxWidth: 70,
        minWidth: 70,
        resizable: false,
        pinned: "right",
      },
      {
        headerName: this.$t("workshop"),
        field: "workshop.name",
        valueGetter: (params) => {
          if (params.data && params.data.workshop && params.data.workshop.name) {
            return params.data.workshop.name;
          } else {
            return this.$t("haveNot");
          }
        },
        width: 150,
        minWidth: 150,
        sortable: true,
      },
      {
        headerName: this.$t("year_"),
        field: "year",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (params.data && params.data.year && params.data.year !== null) {
            return params.data.year;
          } else {
            return this.$t("haveNot");
          }
        },
        width: 80,
        minWidth: 80,
        sortable: true,
      },
      {
        headerName: this.$t("month"),
        field: "month",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (params.data && params.data.month && params.data.month !== null) {
            return params.data.month;
          } else {
            return this.$t("haveNot");
          }
        },
        width: 80,
        minWidth: 80,
        sortable: true,
      },
      {
        headerName: this.$t("personel"),
        field: "employee_count",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (
            params.data &&
            params.data.employee_count &&
            params.data.employee_count !== null
          ) {
            return params.data.employee_count;
          } else {
            return this.$t("haveNot");
          }
        },
        width: 80,
        minWidth: 80,
        sortable: true,
      },
      {
        headerName: this.$t("totalGrossAmount"),
        field: "benefit",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (params.data && params.data.benefit && params.data.benefit !== null) {
            return this.$numberFormat(params.data.benefit);
          } else {
            return this.$t("haveNot");
          }
        },
        width: 180,
        minWidth: 180,
        sortable: true,
      },
      {
        headerName: this.$t("deductions"),
        field: "deductions",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (params.data) {
            const deduction = Number(params.data.deduction) || 0;
            const tax = Number(params.data.tax) || 0;
            const insurance = Number(params.data.employee_insurance) || 0;
            const res = deduction + tax + insurance;
            return this.$numberFormat(res);
          } else {
            return this.$t("haveNot");
          }
        },
        width: 180,
        minWidth: 180,
        sortable: true,
      },
      {
        headerName: this.$t("netPay"),
        field: "netpay",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (params.data) {
            const deduction = Number(params.data.deduction) || 0;
            const tax = Number(params.data.tax) || 0;
            const insurance = Number(params.data.employee_insurance) || 0;
            const total = deduction + tax + insurance;
            const peyment = params.data.benefit;
            const res = peyment - total;
            return this.$numberFormat(res);
          } else {
            return this.$t("haveNot");
          }
        },
        width: 180,
        minWidth: 180,
        sortable: true,
      },
      {
        headerName: this.$t("insurancePayment"),
        field: "insurancePayment",
        valueGetter: (params) => {
          if (params.data) {
            const company = Number(params.data.company_insurance) || 0;
            const employee = Number(params.data.employee_insurance) || 0;
            const res = company + employee;
            return this.$numberFormat(res);
            // return company + employee;
          } else {
            return this.$t("haveNot");
          }
        },
        width: 180,
        minWidth: 180,
        sortable: true,
      },
      {
        headerName: this.$t("status"),
        field: "status",
        cellRenderer: (params) => {
          if (params.data?.status === "done") {
            return `<i class="mdi mdi-check-circle-outline"
                title="${this.$t("confirmed")}"
                style="color:#4CAF50; font-size:24px; cursor:pointer;">
              </i>`;
          }
          return `<i class="mdi mdi-history"
              title="${this.$t("awaitingApproval")}"
              style="color:#FFC107; font-size:24px; cursor:pointer;">
            </i>`;
        },
        width: 90,
        minWidth: 90,
        sortable: true,
      },
    ];
  },
  watch: {
    callRefresh: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.getItems();
          this.$emit("initial-Loading-is", false);
        }
      },
    },
    callFunction: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.editAction(this.row);
        }
      },
    },
  },
  beforeMount() {
    this.getItems();
  },
  methods: {
    generateTime(val) {
      let format = "jYYYY/jMM/jDD";
      let date = val;
      if (!date) return null;
      return moment(date).locale("fa").format(format);
    },
    getItems(isPaginate = false) {
      var app = this;
      if (!isPaginate) {
        app.$emit("initial-Loading-is", true);
      }
      const id_ = app.$route.query.id;
      this.paginationLoading = isPaginate;
      app.$axios
        .get(app.$endpoint + "salary", {
          params: {
            options: app.optionsNew,
          },
        })
        .then((response) => {
          app.rowData = [...response.data.data];
          app.totalRows = response.data.total;
          app.lastPage = response.data.last_page;
          app.$emit("salary-factor-items", {
            items: response.data,
          });
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.$emit("initial-Loading-is", false);
          app.$emit("call-refresh");
          app.paginationLoading = false;
        });
    },
    refreshData() {
      this.getItems(true);
    },
    updatePagination(value) {
      this.optionsNew.page = value;
      this.getItems(true);
    },
    updateItemPerPage(value) {
      this.optionsNew.itemsPerPage = value;
      this.optionsNew.page = 1;
      this.getItems(true);
    },
    editAction(rowData) {
      this.$router.push({
        name: "salery_operations_list",
        query: {
          id: rowData.id,
        },
      });
    },
    editActionAfterDone(rowData) {
      this.$emit("back-to-pending", rowData);
    },
    deleteAction(rowData) {
      var app = this;
      let salaryFactorConfigId = rowData.id;
      app.$axios
        .delete(app.$endpoint + "salary/" + salaryFactorConfigId)
        .then((response) => {})
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          this.getItems(true);
          app.paginationLoading = false;
        });
    },
    goToDocuments(rowData, tab) {
      this.$router.push({
        name: "salary_documents",
        query: {
          id: rowData.id,
          tab: tab,
        },
      });
    },
  },
};
</script>

<style>
.wrapperTable {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.v-skeleton-loader__list-item.v-skeleton-loader__bone {
  align-content: unset;
  align-items: flex-start;
  padding: 0;
}
.theme--light.v-skeleton-loader .v-skeleton-loader__text {
  background: rgb(146 139 139 / 12%);
}
.v-skeleton-loader__text {
  height: 30px;
}
.v-skeleton-loader__list-item {
  height: 41px;
}
</style>
